import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const StyledDecimalInput = styled.input`
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  padding: 10px;
  text-align: right; // Better alignment for numbers

  // Hide browser number input controls
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type="number"] {
    -moz-appearance: textfield;
  }
`

export const DecimalInputContainer = styled(FlexContainer)`
  width: 100%;
  position: relative;
`
